import React from 'react';

import Head from '@zego/components/Head';
import SimpleHeader from '@zego/components/SimpleHeader';

const BasicLayout = ({ title, children }) => (
  <>
    <Head>
      <title>{title}</title>
    </Head>
    <SimpleHeader />
    {children}
  </>
);
export default BasicLayout;
